import { useMutation } from '@tanstack/react-query'

import { updateEvidenceInfo } from '@src/api'
import { DefaultApiUpdateEvidenceInfoRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateEvidenceInfo = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateEvidenceInfoRequest) =>
      updateEvidenceInfo(axiosInstance, params),
  })
}
